// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4j-7";
export var adjustableWidthBorderHeld = "_4j-8";
export var arrow = "_4j-3";
export var arrowButton = "_4j-4";
export var headerCell = "_4j-0";
export var help = "_4j-2";
export var icon = "_4j-1";
export var iconWrapper = "_4j-6";
export var noBorder = "_4j-b";
export var nonAdjustableWidthBorder = "_4j-9";
export var nonAdjustableWidthBorderHeld = "_4j-a";
export var textButton = "_4j-5";